import React from 'react';
import {connect} from 'react-redux';
import {BaseComponent as Component} from 'BaseComponent';
import Action from 'actions';
import Const from 'constants';
import NumberHelper from 'helpers/number-helper';
import InputText from 'components/atoms/inputs/input-text';

class SuperFlexMaxExpPositions extends Component {
    constructor(props) {
        super(props);
        const baseState = this.getBaseState(props);
        if (baseState) {
            this.state = baseState;
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {superFlexMaxExposurePositions} = this.props;
        const {superFlexMaxExposurePositions: prevSuperFlexMaxExposurePositions} = prevProps;

        const shouldStateBeUpdated = (!isEmpty(superFlexMaxExposurePositions) && isEmpty(prevSuperFlexMaxExposurePositions)) || 
            (!isEmpty(prevSuperFlexMaxExposurePositions) && isEmpty(superFlexMaxExposurePositions));

        if (shouldStateBeUpdated) {
            const baseState = this.getBaseState(this.props);
            if (baseState) {
                this.setState(baseState);
            }
        }
    }

    getBaseState(props) {
        const {sportConfig, superFlexMaxExposurePositions} = props;
        let flexPositions = sportConfig.getConfigProp('flexPlayerPosition');
        let positions = sportConfig.getConfigProp('positions');

        if (!positions.hasOwnProperty(flexPositions[Const.POSITION_SUPERFLEX])) {
            return null;
        }

        const flexPosition = positions[flexPositions[Const.POSITION_SUPERFLEX]];

        const state = {};

        Object.keys(flexPosition.allowedPositions).map((key) => {
            let defaultValue = Const.DEFAULT_VALUE_FOR_MAX_EXPOSURE;
            let positionNumber = flexPosition.allowedPositions[key];
            if (!positions.hasOwnProperty(positionNumber)) {
                return;
            }

            let position = positions[positionNumber];
            if (
                !isEmpty(superFlexMaxExposurePositions) &&
                superFlexMaxExposurePositions.hasOwnProperty(position.shortName)
            ) {
                defaultValue = superFlexMaxExposurePositions[position.shortName];
            }
            state[position.shortName] = defaultValue;
        });

        return state;
    }

    onChange(position, e) {
        this.setState({
            [position]: e.target.value,
        });
    }

    onBlur(position, val) {
        let value = NumberHelper.prepareInt(val, Const.DEFAULT_VALUE_FOR_MAX_EXPOSURE)
            .limitByRange(0, Const.DEFAULT_VALUE_FOR_MAX_EXPOSURE, Const.DEFAULT_VALUE_FOR_MAX_EXPOSURE)
            .get();

        this.setState({
            [position]: value,
        });

        this.props.dispatch(
            Action.set('SuperFlexMaxExposurePositions', {
                [position]: value,
            }),
        );
    }

    render() {
        const {sportConfig, label = 'SuperFlex positions'} = this.props;
        let data = {...this.state};

        if (!sportConfig.hasRestrictions()) {
            return false;
        }

        return (
            <div>
                <strong className="filter-sub-title">{label}:</strong>
                <div className="form-inline">
                    {Object.keys(data).map((key) => {
                        let currentValue = data[key];

                        return (
                            <div key={key} className="position-group">
                                <span className="text">{key}</span>
                                <InputText value={currentValue} percent onBlur={(value) => ::this.onBlur(key, value)} />
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {superFlexMaxExposurePositions},
    } = state;
    return {
        sportConfig,
        superFlexMaxExposurePositions,
    };
}

export default connect(mapStatesToProps)(SuperFlexMaxExpPositions);
